import axios from "axios";
import { history } from "routes";
import Swal from "sweetalert2";
import * as Constants from "../constants";
import store from "../store";
import { getHTMLEmitirAlerta } from "../utils/erroEmitirAlerta";
import ToastHelper from "../utils/toastHelper";
import { getToken, logout } from "./auth";
import loadingService from "./loadingService";

const api = axios.create({
	baseURL: process.env.REACT_APP_STAGE
});

const arrayBuf2Obj = buf => {
	var enc = new TextDecoder("utf-8");
	return JSON.parse(enc.decode(buf));
};

const showLoading = () => {
	store.dispatch(loadingService.showLoading());
};

const hideLoading = () => {
	store.dispatch(loadingService.hideLoading());
};

api.interceptors.request.use(
	config => {
		showLoading();

		const token = getToken();

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	error => {
		hideLoading();
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	response => {
		hideLoading();
		return response;
	},
	error => {
		hideLoading();
		if (error.response) {
			const html = getHTMLEmitirAlerta(
				error.response.data.fieldErrors || []
			);
			switch (error.response.data.status || error.response.status) {
				case Constants.STATUS_HTTP_UNAUTHORIZED:
					logout();
					ToastHelper.error(
						"Seu tempo de sessão expirou. Faça login novamente para continuar."
					);
					history.push({
						pathname: "/"
					});
					break;

				case Constants.STATUS_HTTP_FORBIDDEN:
					history.push({
						pathname: "/home"
					});
					break;

				case Constants.STATUS_HTTP_ERRO_INTERNO:
					ToastHelper.error(
						"Ocorreu um erro no sistema, contate o administrador do sistema."
					);
					break;

				case Constants.STATUS_HTTP_VALIDACAO:
					if (error.response.config.modulo === "alertas") {
						Swal.fire({
							title: "Atenção!",
							html,
							type: "warning",
							confirmButtonText: "OK"
						});
					} else {
						ToastHelper.warn(error.response.data.message);
					}
					break;

				case Constants.STATUS_BASE_EXCEPTION:
					if (error.response.data instanceof ArrayBuffer) {
						ToastHelper.warn(
							arrayBuf2Obj(error.response.data).message
						);
					} else {
						ToastHelper.warn(error.response.data.message);
					}
					break;

				default:
					ToastHelper.error(
						"Ocorreu um erro no sistema, contate o administrador do sistema."
					);
					break;
			}
		}

		return Promise.reject(error);
	}
);

export default api;
